// src/services/region.service.js
import api from './api';

const regionService = {
  // Create region
  createRegion: async (regionData) => {
    try {
      const response = await api.post('/regions', regionData);
      return response.data;
    } catch (error) {
      console.error('Error creating region:', error);
      throw error;
    }
  },

  // Get all regions (paginated)
  getRegions: async (companyId, page = 1, limit = 10, search = '') => {
    try {
      const params = { page, limit };
      if (search) params.search = search;
      if (companyId) params.companyId = companyId;

      const response = await api.get('/regions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching regions:', error);
      throw error;
    }
  },

  
  // Get all regions (no pagination - for dropdowns)
   getAllRegions: async (companyId = null) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    const res = await api.get('/regions/all', { params });
    return res.data;
  },

  // Get region by ID
  getRegionById: async (id) => {
    try {
      const response = await api.get(`/regions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching region:', error);
      throw error;
    }
  },

  // Update region
  updateRegion: async (id, regionData) => {
    try {
      const response = await api.post(`/regions/${id}`, regionData);
      return response.data;
    } catch (error) {
      console.error('Error updating region:', error);
      throw error;
    }
  },

  // Delete region
  deleteRegion: async (id) => {
    try {
      const response = await api.delete(`/regions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting region:', error);
      throw error;
    }
  },

  // Get regions across all companies (for global resources like godowns)
getAllRegionsGlobal: async () => {
  try {
    const response = await api.get('/regions/all-global');
    return response.data;
  } catch (error) {
    console.error('Error fetching global regions:', error);
    throw error;
  }
},
};


export default regionService;